import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from "./agentFullScreen.module.scss";
import VideoSmall from '../../webChatScreen/videoWidgets/videoSmall';
import store from '../../../store/redux-store/root_store';
import _ from 'lodash';
import { formatTime, iterateSoreChat, setRecTimer, sipCallEnd, stopScreenSharing, trunketName, updateCCLang, updateFullScreen } from '../../../base/video_common';
import { videoCallService } from '../../../base/service/videoCallService';
import { deviceState, initialStateModel } from '../../../base/models/meetModal';
import { video_disable, meetService } from '../../../services/meetService';
import CloseCaptionCommon from '../closeCaption/closecaption';
import { useDispatch, useSelector } from 'react-redux';
import VideoMeetingChat from '../meetChat/index';
import { actionTypes, meetActionTypes } from '../../../base/action/action';
import VideoShareLeftBar from '../videoleftbar';
import audion from "../../../styles/images/audion.svg";
import audioh from "../../../styles/images/audioh.svg";
import audioa from "../../../styles/images/audioa.svg";
import agentchatn from "../../../styles/images/agentChat.svg";
import agentchath from "../../../styles/images/agentChath.svg";
import agentchata from "../../../styles/images/agentChata.svg";
import agentchatad from "../../../styles/images/agentchatad.svg"
import videon from "../../../styles/images/videon.svg";
import videoh from "../../../styles/images/videoh.svg";
import videoa from "../../../styles/images/videoa.svg";
import chatn from "../../../styles/images/chatn.svg";
import chath from "../../../styles/images/chath.svg";
import chata from "../../../styles/images/chata.svg";
import chatd from "../../../styles/images/chatd.svg";
import ccn from "../../../styles/images/ccn.svg";
import cch from "../../../styles/images/cch.svg";
import cca from "../../../styles/images/cca.svg";
import recordn from "../../../styles/images/recordn.svg";
import recorda from "../../../styles/images/recorda.svg";
import recordh from "../../../styles/images/recordh.svg";
import sharen from "../../../styles/images/sharen.svg";
import sharea from "../../../styles/images/sharea.svg";
import shareh from "../../../styles/images/shareh.svg";
import ChatRightSideBar from '../../webChatScreen/chatWidgets/chatRightSidebar';
import { Button, Modal, Popover, notification, Tooltip } from 'antd';
import MeetTranscription from '../meetTranscription';
import Draggable from "react-draggable";
import { checkShareStatus, drawLineAgent, getIcon, mouseMove, moveClick, moveRelease, setAnnotateOpt, setRemoteVideo, undo } from '../../../annotation';
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { CallServices } from '../../../base/service/apiServices';
import { VirtualBGRender } from '../virtualBGRrender';
import { VirtualBGModel } from '../../virtualBackground/core/helpers/VBModel';
import { SegmentationConfig } from '../../virtualBackground/core/helpers/segmentationHelper';
import { PostProcessingConfig } from '../../virtualBackground/core/helpers/postProcessingHelper';
import { BackgroundConfig } from '../../virtualBackground/core/helpers/backgroundHelper';
import axios from 'axios';

export default function AgentFullScreen() {
  const { activeParticipantList, currdeviceinfo, componentState, fullScreenAgent, recTimer, elapsedTime, pauseTime, recordPopup,vmSettings,vmTransfer,vmTransferTimer } = store.getState().meetingReducer;
  const { sharingStatus,annotation,annotationEnable,annotationPopup,remoteVideoSize } = store.getState().sharingReducerState;
  const [endModal, setEndModal] = useState(false);
  const {chatConvo,toParticipant}:any=store.getState().messageReducer;
  const { closeCaptionText, expandHide, showOriginalText, ccBtns,ccLang } = store.getState().closeCaption;
  const closeCaption: any = useSelector((state: any) => state.closeCaption);
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const sharingReducerState: any = useSelector((state: any) => state.sharingReducerState);
  const messageReducer: any = useSelector((state: any) => state.messageReducer);
  const stored_Video:any=useSelector((state:any)=>state.storeVideo)
  const [lang, setLang] = useState(['Global English (en) - default', 'Spanish (es)',
    'French (fr)', 'Portuguese (pt)', 'Japanese (ja)', 'Korean (ko)', 'Tamil (ta)', 'Telugu (te)', 'Hindi (hi)', 'Arabic (ar)', 'Bengali (bn)', 'Russian (ru)', 'Polish (pl)', 'Romanian (ro)', 'Urdu (ur)'])
  let dispatch: any = useDispatch();
  let activeSpeaker: any = store.getState().meetingReducer;
  let activeSpeakerState: any = activeSpeaker || {}
  let participantVideo: any = useRef(null);
  let screenShareVideo: any = useRef(null);
  // const virtualBGState: { image: any, imgIndex: number, viewMode: string }
  // = useSelector((state: initialStateModel) => state.VirtualBG);
  let remVideo: any = useRef(null);
  const [recSettings,setRecSettings]=useState({});
  const [opt,setOpt]:any=useState("");
  let remotedev: any = activeParticipantList.filter((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
  const [switchStream, setSwitchStream] = useState<any>(false);
  const Draggable1: any = Draggable;
  const [count,setCount]=useState(0);
  const [recPop,setRecPop]=useState(false)
  let publicChat:any=0;
  const meetingDetails: any = store.getState().meetingReducer || {};
  const canvasEL: any = document.getElementById('canvas123');
  const gl = canvasEL.getContext('webgl2') || null;
  const getRes = new VirtualBGModel(gl ? 'mlkit' : 'bodyPix', true, "webgl");

  const [
    segmentationConfig,
    setSegmentationConfig
  ] = useState<SegmentationConfig>(getRes.getResolutionDetails());

  const [
    postProcessingConfig,
    setPostProcessingConfig
  ] = useState<PostProcessingConfig>({
    smoothSegmentationMask: false,
    jointBilateralFilter: { sigmaSpace: 5.6, sigmaColor: 0.3 },
    coverage: [0.5, 0.75],
    lightWrapping: 0.1,
    blendMode: 'screen'
  });
  const backgroundConfig: BackgroundConfig =
    { "type": "image", "url": (!_.isEmpty(vmSettings) && vmSettings.isVirtualBackground !==0 && vmSettings.virtualBackground!== null && vmSettings.virtualBackgroundId !== null) ?  vmSettings.virtualBackground : ""};
    let playbackInfo:any="";
   if(participantVideo.current){
      playbackInfo = {
        htmlElement: participantVideo.current,
        width: participantVideo.current?.videoWidth,
        height: participantVideo.current?.videoHeight
      };
    
    }
  useEffect(() => {
    setRecordSettings();
  }, [JSON.stringify(closeCaption),,annotation?.length,screenShareVideo,annotationEnable,annotationPopup,remoteVideoSize,JSON.stringify(sharingReducerState)])

  const switchVideoStream = () => {
    setSwitchStream(!switchStream);
  }

const setRecordSettings=async ()=>{
  const res = await CallServices.get("/get_setting_voice_video_recording")
  if (res?.data?.callConfigRes && Array.isArray(res?.data?.callConfigRes) && res?.data?.statusCode === 200) {
    const rec = res?.data?.callConfigRes[0]
    setRecSettings(rec)
  }
}
  useEffect(() => {
    if (currdeviceinfo.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: currdeviceinfo.conId });
      if (videoData !== undefined && videoData.stream !== '' && participantVideo.current) {
        if ((participantVideo.current.srcObject === null)
          || (participantVideo.current.srcObject.id !== videoData.stream.id)) {
          participantVideo.current.srcObject = videoData.stream;
        }
      }
    }
    if(remotedev){if (remotedev[0]?.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: remotedev[0]?.conId });
      if (videoData !== undefined && videoData.stream !== '' && remVideo.current) {
        if ((remVideo.current.srcObject === null)
          || (remVideo.current.srcObject.id !== videoData.stream.id)) {
          remVideo.current.srcObject = videoData.stream;
        }
      }
    }}
    if(componentState !=="meetChat"){setCount(0)}
  }, [activeSpeakerState, sharingStatus, activeParticipantList, stored_Video, stored_Video.participantList.length, activeParticipantList.length, recordPopup,componentState])

  useEffect(() => {

  }, [closeCaptionText[closeCaptionText?.length - 1]?.length, closeCaptionText?.length])




  useLayoutEffect(() => {
   if(sharingReducerState.sharingStatus){ let videoData = stored_Video.participantList.find((participant: any) => participant.participants === sharingReducerState.conId);

        if (sharingStatus && videoData !== undefined && videoData.stream !== "") {
            console.log("videoData ======",videoData);

            if (screenShareVideo?.current && (screenShareVideo.current.srcObject === null || screenShareVideo.current.srcObject?.id !== videoData.stream.id)) {
                
                screenShareVideo.current.srcObject = videoData.stream;
                screenShareVideo.current.muted = true;
            }
        }
  }
}, [sharingStatus, stored_Video, stored_Video.participantList.length,opt]);

  const continueRecording = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    // videoCallService.recordingAction("start", currdeviceinfo.conId);
    store.dispatch({
      type: meetActionTypes.RECORD_POPUP,
      payload: { recordPopup: false }
    })

    videoCallService.reqRec(remotedev[0]?.conId);
  }
  const muteAudio = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    let mediaDeviceInfo: deviceState = store.getState().mediaDevice;


    if (mediaDeviceInfo.isAudio) {

      let input: any = {};
      input.socketId = currdeviceinfo["conId"];
      input.mute = !currdeviceinfo.mute;
      videoCallService.audioStatus(input);

    } else {
      notification.info({
        message: `${mediaDeviceInfo.isAudioStatus}`,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
  };


  const startCloseCaption = () => {

    let input: any = {};
    input.socketId = currdeviceinfo['conId'];

    if (!ccBtns) {
      videoCallService.startCloseCaption(input);
    }
    else {
      try {
        let stopinput: any = {};
        stopinput.socketId = currdeviceinfo['conId'];
        videoCallService.stopCloseCaption(stopinput);
      }
      catch (e: any) {
        console.log("error");
      }
    }
  }

  const muteVideo = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    let mediaDeviceInfo: deviceState = store.getState().mediaDevice;
    if (mediaDeviceInfo.isVideo) {
      let input: any = {};
      input.socketId = currdeviceinfo['conId'];
      input.video = !currdeviceinfo.video;
      if (currdeviceinfo.video) { video_disable(input); }
      else { new meetService(dispatch).sendRe_invite(input); }
    }
    else {
      notification.info({
        message: `${mediaDeviceInfo.isVideoStatus}`,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
  };


  const end = () => {
    setEndModal(true);
  }

  const endall = () => {
    console.log("end call func trigger==");
    setEndModal(false);
    sipCallEnd();
    videoCallService.endMeeting('endall');
  }

  const onshareScreen = () => {

    let check = checkShareStatus();
    if (check.status) {
      new meetService(dispatch).startSharing()
    } else {
      notification.info({
        message: check.error,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
 
}
  const meetChat = () => {
    store.dispatch({
      type: meetActionTypes.MEETING_CONTROL_OPEN,
      payload: {
        componentState: "meetChat"
      }
    })
    iterateSoreChat(toParticipant);
    setCount(0);
  }


  const openInternalChat = () => {
    store.dispatch({
      type: meetActionTypes.MEETING_CONTROL_OPEN,
      payload: {
        componentState: "internalChat"
      }
    })
  }

  const fullScreen = () => {
    try {
      updateFullScreen(false);
    } catch (e: any) {
      console.log("e is", e);
    }
  }

  const updateCCLanguageSelection = (lang: any, language: any) => {
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let input: any = {};
    input.socketId = currdeviceinfo['conId'];
    input.lang = lang;
    updateCCLang(lang);
    videoCallService.updateLang(input);
    notification.info({
      message: `CC changed to ${language}`,
      placement: "top",
      className: "toastNotification success",
      icon: <span className="icon__Success24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,
    });
  }

  const openTranscription = () => {
    store.dispatch({
      type: meetActionTypes.MEETING_CONTROL_OPEN,
      payload: {
        componentState: "meetTranscription"
      },
    });
  }

  const stopShare = () => {
    stopScreenSharing();
  }

  const content = (
    <div className="moreoptionpop">
      <div className="profileAreaPopover">
        <div className="userDetails">
          <span className="langTitle">CC Languages</span>
          <ul className="scroller langSelection">
            {lang.includes('Global English (en) - default') && <li onClick={() => updateCCLanguageSelection('en', "English")}><span className="title1">English</span></li>}
            {lang.includes('Arabic (ar)') && <li onClick={() => updateCCLanguageSelection('ar', "Arabic")}><span className="title1">Arabic</span></li>}
            {lang.includes('Bengali (bn)') && <li onClick={() => updateCCLanguageSelection('bn', "Bengali")}><span className="title1">Bengali</span></li>}
            {lang.includes('French (fr)') && <li onClick={() => updateCCLanguageSelection('fr', "French")}><span className="title1">French</span></li>}
            {lang.includes('Hindi (hi)') && <li onClick={() => updateCCLanguageSelection('hi', "Hindi")}><span className="title1">Hindi</span></li>}
            {lang.includes('Japanese (ja)') && <li onClick={() => updateCCLanguageSelection('ja', "Japanese")}><span className="title1">Japanese</span></li>}
            {lang.includes('Korean (ko)') && <li onClick={() => updateCCLanguageSelection('ko', "Korean")}><span className="title1">Korean</span></li>}
            {lang.includes('Polish (pl)') && <li onClick={() => updateCCLanguageSelection('pl', "Polish")}><span className="title1">Polish</span></li>}
            {lang.includes('Portuguese (pt)') && <li onClick={() => updateCCLanguageSelection('pt', "Portuguese")}><span className="title1">Portuguese</span></li>}
            {lang.includes('Romanian (ro)') && <li onClick={() => updateCCLanguageSelection('ro', "Romanian")}><span className="title1">Romanian</span></li>}
            {lang.includes('Russian (ru)') && <li onClick={() => updateCCLanguageSelection('ru', "Russian")}><span className="title1">Russian</span></li>}
            {lang.includes('Spanish (es)') && <li onClick={() => updateCCLanguageSelection('es', "Spanish")}><span className="title1">Spanish</span></li>}
            {lang.includes('Tamil (ta)') && <li onClick={() => updateCCLanguageSelection('ta', "Tamil")}><span className="title1">Tamil</span></li>}
            {lang.includes('Telugu (te)') && <li onClick={() => updateCCLanguageSelection('te', "Telugu")}><span className="title1">Telugu</span></li>}
            {lang.includes('Urdu (ur)') && <li onClick={() => updateCCLanguageSelection('ur', "Urdu")}><span className="title1">Urdu</span></li>}

          </ul>
        </div>
      </div>
    </div>
  );

  const record = (action: any) => {

    if (action === "pause") {
     videoCallService.recordingAction("pause", currdeviceinfo.conId);

   }
   else if (action === "resume") {
     videoCallService.recordingAction("resume", currdeviceinfo.conId);

   }
   else {
     videoCallService.recordingAction("stop", currdeviceinfo.conId);
   }
  }

  const recordParticipant = (action: any) => {
    if (action === "start") {
      store.dispatch({
        type: meetActionTypes.RECORD_POPUP,
        payload: { recordPopup: true }
      })
    }
    else if (action === "pause") {
      setRecPop(true);
      videoCallService.recordingAction("pause", currdeviceinfo.conId);

    }
    else if (action === "resume") {
      setRecPop(true);
      videoCallService.recordingAction("resume", currdeviceinfo.conId);

    }
    else {
      videoCallService.recordingAction("stop", currdeviceinfo.conId);
    }
  }

  const openRecModal = () => {
    if (currdeviceinfo.recordingStatus === "stop") {
      store.dispatch({
        type: meetActionTypes.RECORD_POPUP,
        payload: {
          recordPopup: true
        }
      })
    }
    if(currdeviceinfo.recordingStatus !=="stop" ){setRecPop(!recPop)}
  }

  const backToReset = () => {
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let input: any = {};
    input.socketId = currdeviceinfo['conId'];
    input.lang = "en";
    updateCCLang(lang);
    videoCallService.updateLang(input);
}

  useEffect(() => {
    let timerInterval: any;

    if (currdeviceinfo.recordingStatus === "start" || currdeviceinfo.recordingStatus === "resume") {
      timerInterval = setInterval(() => {
        const currentTime = Date.now();
        const totalElapsedTime = (currentTime - recTimer);
        setRecTimer(recTimer, pauseTime, totalElapsedTime)
      }, 1000);
    }

    return () => clearInterval(timerInterval);
  }, [currdeviceinfo.recordingStatus, elapsedTime, recTimer]);
  const contentrecord = (
    <div className="chatrecordbox">
      <p><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
        <path d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z" fill="#DE003D" />
      </svg>{(currdeviceinfo.recordingStatus === "start" || currdeviceinfo.recordingStatus === "resume") ? `Recording...` : `Recording paused...`}</p>
      <h4>{formatTime(elapsedTime)}</h4>
      {(currdeviceinfo.recordingStatus === "resume" || currdeviceinfo.recordingStatus === "start") && <div onClick={() => recordParticipant("pause")}>
        <svg width="226" height="38" viewBox="0 0 226 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="225" height="37" rx="5.5" fill="#e6e4eb" />
          <rect x="0.5" y="0.5" width="225" height="37" rx="5.5" stroke="#e6e4eb" />
          <g clip-path="url(#clip0_2803_28552)">
            <path d="M92.3325 13.666H91.3332C90.5968 13.666 89.9999 14.2629 89.9999 14.9993V22.9993C89.9999 23.7357 90.5968 24.3327 91.3332 24.3327H92.3325C93.0689 24.3327 93.6659 23.7357 93.6659 22.9993V14.9993C93.6659 14.2629 93.0689 13.666 92.3325 13.666ZM92.6659 22.9993C92.6659 23.1831 92.5163 23.3327 92.3325 23.3327H91.3332C91.1494 23.3327 90.9999 23.1831 90.9999 22.9993V14.9993C90.9999 14.8156 91.1494 14.666 91.3332 14.666H92.3325C92.5163 14.666 92.6659 14.8156 92.6659 14.9993V22.9993Z" fill="#3E3F40" />
            <path d="M86.6666 13.666H85.6673C84.9309 13.666 84.334 14.2629 84.334 14.9993V22.9993C84.334 23.7357 84.9309 24.3327 85.6673 24.3327H86.6666C87.403 24.3327 87.9999 23.7357 87.9999 22.9993V14.9993C87.9999 14.2629 87.403 13.666 86.6666 13.666ZM86.9999 22.9993C86.9999 23.1831 86.8504 23.3327 86.6666 23.3327H85.6673C85.4835 23.3327 85.334 23.1831 85.334 22.9993V14.9993C85.334 14.8156 85.4835 14.666 85.6673 14.666H86.6666C86.8504 14.666 86.9999 14.8156 86.9999 14.9993V22.9993Z" fill="#3E3F40" />
          </g>
          <path d="M104.298 24V13.8182H108.116C108.899 13.8182 109.555 13.964 110.085 14.2557C110.619 14.5473 111.021 14.9484 111.293 15.4588C111.568 15.9659 111.706 16.5426 111.706 17.1889C111.706 17.8419 111.568 18.4219 111.293 18.929C111.018 19.4361 110.612 19.8355 110.075 20.1271C109.538 20.4155 108.877 20.5597 108.092 20.5597H105.561V19.0433H107.843C108.3 19.0433 108.675 18.9638 108.967 18.8047C109.258 18.6456 109.474 18.4268 109.613 18.1484C109.755 17.87 109.827 17.5502 109.827 17.1889C109.827 16.8277 109.755 16.5095 109.613 16.2344C109.474 15.9593 109.257 15.7455 108.962 15.593C108.67 15.4373 108.294 15.3594 107.833 15.3594H106.143V24H104.298ZM115.289 24.1541C114.805 24.1541 114.369 24.0679 113.982 23.8956C113.597 23.7199 113.292 23.4614 113.067 23.12C112.845 22.7786 112.734 22.3577 112.734 21.8572C112.734 21.4264 112.813 21.0701 112.972 20.7884C113.131 20.5066 113.349 20.2812 113.624 20.1122C113.899 19.9432 114.209 19.8156 114.553 19.7294C114.901 19.6399 115.261 19.5753 115.632 19.5355C116.08 19.4891 116.443 19.4477 116.721 19.4112C116.999 19.3714 117.202 19.3118 117.328 19.2322C117.457 19.1494 117.521 19.0218 117.521 18.8494V18.8196C117.521 18.4451 117.41 18.1551 117.188 17.9496C116.966 17.7441 116.646 17.6413 116.229 17.6413C115.788 17.6413 115.438 17.7375 115.18 17.9297C114.925 18.1219 114.752 18.349 114.663 18.6108L112.982 18.3722C113.115 17.9081 113.334 17.5204 113.639 17.2088C113.944 16.8939 114.316 16.6586 114.757 16.5028C115.198 16.3438 115.685 16.2642 116.219 16.2642C116.587 16.2642 116.953 16.3073 117.318 16.3935C117.682 16.4796 118.015 16.6222 118.317 16.821C118.618 17.0166 118.86 17.2834 119.043 17.6214C119.228 17.9595 119.321 18.3821 119.321 18.8892V24H117.591V22.951H117.531C117.422 23.1631 117.268 23.362 117.069 23.5476C116.873 23.7299 116.627 23.8774 116.328 23.9901C116.033 24.0994 115.687 24.1541 115.289 24.1541ZM115.756 22.8317C116.118 22.8317 116.431 22.7604 116.696 22.6179C116.961 22.4721 117.165 22.2798 117.308 22.0412C117.453 21.8026 117.526 21.5424 117.526 21.2607V20.3608C117.47 20.4072 117.374 20.4503 117.238 20.4901C117.105 20.5298 116.956 20.5646 116.791 20.5945C116.625 20.6243 116.461 20.6508 116.298 20.674C116.136 20.6972 115.995 20.7171 115.876 20.7337C115.607 20.7701 115.367 20.8298 115.155 20.9126C114.943 20.9955 114.775 21.1115 114.653 21.2607C114.53 21.4065 114.469 21.5954 114.469 21.8274C114.469 22.1589 114.59 22.4091 114.832 22.5781C115.074 22.7472 115.382 22.8317 115.756 22.8317ZM125.998 20.7884V16.3636H127.798V24H126.053V22.6428H125.973C125.801 23.0703 125.517 23.42 125.123 23.6918C124.732 23.9635 124.25 24.0994 123.676 24.0994C123.176 24.0994 122.733 23.9884 122.349 23.7663C121.968 23.541 121.669 23.2145 121.454 22.7869C121.238 22.3561 121.131 21.8357 121.131 21.2259V16.3636H122.93V20.9474C122.93 21.4313 123.063 21.8158 123.328 22.1009C123.593 22.3859 123.941 22.5284 124.372 22.5284C124.637 22.5284 124.894 22.4638 125.143 22.3345C125.391 22.2053 125.595 22.013 125.754 21.7578C125.917 21.4993 125.998 21.1761 125.998 20.7884ZM135.684 18.3821L134.043 18.5611C133.997 18.3954 133.916 18.2396 133.8 18.0938C133.687 17.9479 133.534 17.8303 133.342 17.7408C133.15 17.6513 132.915 17.6065 132.636 17.6065C132.262 17.6065 131.947 17.6877 131.692 17.8501C131.44 18.0125 131.315 18.223 131.319 18.4815C131.315 18.7036 131.397 18.8842 131.562 19.0234C131.731 19.1626 132.01 19.277 132.398 19.3665L133.7 19.6449C134.423 19.8007 134.96 20.0476 135.311 20.3857C135.666 20.7237 135.845 21.1662 135.848 21.7131C135.845 22.1937 135.704 22.6179 135.425 22.9858C135.15 23.3504 134.767 23.6354 134.277 23.8409C133.786 24.0464 133.223 24.1491 132.587 24.1491C131.652 24.1491 130.9 23.9536 130.329 23.5625C129.759 23.1681 129.42 22.6196 129.31 21.9169L131.065 21.7479C131.145 22.0926 131.314 22.3527 131.572 22.5284C131.831 22.7041 132.167 22.7919 132.582 22.7919C133.009 22.7919 133.352 22.7041 133.611 22.5284C133.873 22.3527 134.003 22.1357 134.003 21.8771C134.003 21.6584 133.919 21.4777 133.75 21.3352C133.584 21.1927 133.326 21.0833 132.974 21.0071L131.672 20.7337C130.939 20.5812 130.397 20.3243 130.046 19.9631C129.695 19.5985 129.521 19.1378 129.524 18.581C129.521 18.1103 129.648 17.7027 129.907 17.358C130.169 17.0099 130.532 16.7415 130.996 16.5526C131.463 16.3603 132.002 16.2642 132.611 16.2642C133.506 16.2642 134.211 16.4548 134.724 16.8359C135.241 17.2171 135.561 17.7325 135.684 18.3821ZM140.713 24.1491C139.947 24.1491 139.286 23.9901 138.729 23.6719C138.175 23.3504 137.75 22.8963 137.451 22.3097C137.153 21.7197 137.004 21.0253 137.004 20.2266C137.004 19.4411 137.153 18.7517 137.451 18.1584C137.753 17.5618 138.174 17.0978 138.714 16.7663C139.254 16.4316 139.889 16.2642 140.618 16.2642C141.089 16.2642 141.533 16.3404 141.951 16.4929C142.371 16.642 142.743 16.8741 143.064 17.1889C143.389 17.5038 143.644 17.9048 143.83 18.392C144.015 18.8759 144.108 19.4527 144.108 20.1222V20.674H137.849V19.4609H142.383C142.38 19.1162 142.305 18.8097 142.159 18.5412C142.014 18.2694 141.81 18.0556 141.548 17.8999C141.289 17.7441 140.988 17.6662 140.643 17.6662C140.275 17.6662 139.952 17.7557 139.674 17.9347C139.395 18.1103 139.178 18.3423 139.022 18.6307C138.87 18.9157 138.792 19.2289 138.789 19.5703V20.6293C138.789 21.0734 138.87 21.4545 139.032 21.7727C139.195 22.0876 139.422 22.3295 139.713 22.4986C140.005 22.6643 140.346 22.7472 140.737 22.7472C140.999 22.7472 141.236 22.7107 141.448 22.6378C141.661 22.5616 141.844 22.4505 142 22.3047C142.156 22.1589 142.274 21.9782 142.353 21.7628L144.034 21.9517C143.928 22.3958 143.725 22.7836 143.427 23.1151C143.132 23.4432 142.754 23.6984 142.294 23.8807C141.833 24.0597 141.306 24.1491 140.713 24.1491Z" fill="#3E3F40" />
          <defs>
            <clipPath id="clip0_2803_28552">
              <rect width="16" height="16" fill="white" transform="translate(81 11)" />
            </clipPath>
          </defs>
        </svg>

      </div>}
      {(currdeviceinfo.recordingStatus === "pause") && <div onClick={() => recordParticipant("resume")}>

        <svg width="226" height="38" viewBox="0 0 226 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="225" height="37" rx="5.5" stroke="#AAACAD" />
          <g clip-path="url(#clip0_2803_68992)">
            <path d="M88.5384 16.9154L83.7004 14.1265L78.8624 11.3377C78.4726 11.1178 78.0627 11.0078 77.6629 11.0078C76.4034 11.0078 75.2539 12.0174 75.2539 13.4168V24.5822C75.2539 25.9916 76.4034 26.9912 77.6629 26.9912C78.0627 26.9912 78.4726 26.8912 78.8624 26.6613L83.7004 23.8725L88.5384 21.0836C90.1477 20.154 90.1477 17.835 88.5384 16.9154Z" fill="#3E3F40" />
          </g>
          <path d="M101.825 24V13.8182H105.643C106.425 13.8182 107.081 13.9541 107.612 14.2259C108.145 14.4976 108.548 14.8788 108.82 15.3693C109.095 15.8565 109.232 16.425 109.232 17.0746C109.232 17.7275 109.093 18.2943 108.815 18.7749C108.54 19.2521 108.134 19.6217 107.597 19.8835C107.06 20.142 106.4 20.2713 105.618 20.2713H102.898V18.7401H105.369C105.827 18.7401 106.201 18.6771 106.493 18.5511C106.785 18.4219 107 18.2346 107.139 17.9893C107.282 17.7408 107.353 17.4358 107.353 17.0746C107.353 16.7133 107.282 16.4051 107.139 16.1499C106.997 15.8913 106.78 15.6958 106.488 15.5632C106.196 15.4273 105.82 15.3594 105.359 15.3594H103.669V24H101.825ZM107.085 19.3864L109.605 24H107.547L105.071 19.3864H107.085ZM114.122 24.1491C113.356 24.1491 112.695 23.9901 112.138 23.6719C111.585 23.3504 111.159 22.8963 110.86 22.3097C110.562 21.7197 110.413 21.0253 110.413 20.2266C110.413 19.4411 110.562 18.7517 110.86 18.1584C111.162 17.5618 111.583 17.0978 112.123 16.7663C112.663 16.4316 113.298 16.2642 114.027 16.2642C114.498 16.2642 114.942 16.3404 115.36 16.4929C115.781 16.642 116.152 16.8741 116.473 17.1889C116.798 17.5038 117.053 17.9048 117.239 18.392C117.425 18.8759 117.517 19.4527 117.517 20.1222V20.674H111.258V19.4609H115.792C115.789 19.1162 115.714 18.8097 115.569 18.5412C115.423 18.2694 115.219 18.0556 114.957 17.8999C114.699 17.7441 114.397 17.6662 114.052 17.6662C113.684 17.6662 113.361 17.7557 113.083 17.9347C112.804 18.1103 112.587 18.3423 112.431 18.6307C112.279 18.9157 112.201 19.2289 112.198 19.5703V20.6293C112.198 21.0734 112.279 21.4545 112.441 21.7727C112.604 22.0876 112.831 22.3295 113.123 22.4986C113.414 22.6643 113.756 22.7472 114.147 22.7472C114.408 22.7472 114.645 22.7107 114.858 22.6378C115.07 22.5616 115.254 22.4505 115.409 22.3047C115.565 22.1589 115.683 21.9782 115.762 21.7628L117.443 21.9517C117.337 22.3958 117.135 22.7836 116.836 23.1151C116.541 23.4432 116.163 23.6984 115.703 23.8807C115.242 24.0597 114.715 24.1491 114.122 24.1491ZM125.075 18.3821L123.435 18.5611C123.388 18.3954 123.307 18.2396 123.191 18.0938C123.079 17.9479 122.926 17.8303 122.734 17.7408C122.542 17.6513 122.306 17.6065 122.028 17.6065C121.653 17.6065 121.338 17.6877 121.083 17.8501C120.831 18.0125 120.707 18.223 120.71 18.4815C120.707 18.7036 120.788 18.8842 120.954 19.0234C121.123 19.1626 121.401 19.277 121.789 19.3665L123.092 19.6449C123.814 19.8007 124.351 20.0476 124.703 20.3857C125.057 20.7237 125.236 21.1662 125.24 21.7131C125.236 22.1937 125.095 22.6179 124.817 22.9858C124.542 23.3504 124.159 23.6354 123.669 23.8409C123.178 24.0464 122.615 24.1491 121.978 24.1491C121.044 24.1491 120.291 23.9536 119.721 23.5625C119.151 23.1681 118.811 22.6196 118.702 21.9169L120.457 21.7479C120.536 22.0926 120.705 22.3527 120.964 22.5284C121.222 22.7041 121.559 22.7919 121.973 22.7919C122.401 22.7919 122.744 22.7041 123.002 22.5284C123.264 22.3527 123.395 22.1357 123.395 21.8771C123.395 21.6584 123.311 21.4777 123.142 21.3352C122.976 21.1927 122.717 21.0833 122.366 21.0071L121.063 20.7337C120.331 20.5812 119.789 20.3243 119.438 19.9631C119.086 19.5985 118.912 19.1378 118.916 18.581C118.912 18.1103 119.04 17.7027 119.298 17.358C119.56 17.0099 119.923 16.7415 120.387 16.5526C120.855 16.3603 121.393 16.2642 122.003 16.2642C122.898 16.2642 123.602 16.4548 124.116 16.8359C124.633 17.2171 124.953 17.7325 125.075 18.3821ZM131.591 20.7884V16.3636H133.39V24H131.645V22.6428H131.566C131.394 23.0703 131.11 23.42 130.716 23.6918C130.325 23.9635 129.842 24.0994 129.269 24.0994C128.769 24.0994 128.326 23.9884 127.942 23.7663C127.56 23.541 127.262 23.2145 127.047 22.7869C126.831 22.3561 126.724 21.8357 126.724 21.2259V16.3636H128.523V20.9474C128.523 21.4313 128.656 21.8158 128.921 22.1009C129.186 22.3859 129.534 22.5284 129.965 22.5284C130.23 22.5284 130.487 22.4638 130.736 22.3345C130.984 22.2053 131.188 22.013 131.347 21.7578C131.51 21.4993 131.591 21.1761 131.591 20.7884ZM135.241 24V16.3636H136.961V17.6612H137.051C137.21 17.2237 137.473 16.8823 137.841 16.6371C138.209 16.3885 138.648 16.2642 139.159 16.2642C139.676 16.2642 140.112 16.3902 140.466 16.642C140.824 16.8906 141.076 17.2304 141.222 17.6612H141.301C141.471 17.237 141.756 16.8989 142.157 16.647C142.561 16.3918 143.04 16.2642 143.593 16.2642C144.296 16.2642 144.869 16.4863 145.314 16.9304C145.758 17.3745 145.98 18.0225 145.98 18.8743V24H144.175V19.1527C144.175 18.6787 144.049 18.3324 143.797 18.1136C143.545 17.8916 143.237 17.7805 142.873 17.7805C142.438 17.7805 142.099 17.9164 141.853 18.1882C141.611 18.4567 141.49 18.8063 141.49 19.2372V24H139.725V19.0781C139.725 18.6837 139.606 18.3688 139.368 18.1335C139.132 17.8982 138.824 17.7805 138.443 17.7805C138.184 17.7805 137.949 17.8468 137.737 17.9794C137.525 18.1087 137.356 18.2926 137.23 18.5312C137.104 18.7666 137.041 19.0417 137.041 19.3565V24H135.241ZM151.186 24.1491C150.421 24.1491 149.759 23.9901 149.203 23.6719C148.649 23.3504 148.223 22.8963 147.925 22.3097C147.627 21.7197 147.477 21.0253 147.477 20.2266C147.477 19.4411 147.627 18.7517 147.925 18.1584C148.227 17.5618 148.647 17.0978 149.188 16.7663C149.728 16.4316 150.363 16.2642 151.092 16.2642C151.562 16.2642 152.007 16.3404 152.424 16.4929C152.845 16.642 153.216 16.8741 153.538 17.1889C153.863 17.5038 154.118 17.9048 154.303 18.392C154.489 18.8759 154.582 19.4527 154.582 20.1222V20.674H148.323V19.4609H152.857C152.853 19.1162 152.779 18.8097 152.633 18.5412C152.487 18.2694 152.283 18.0556 152.021 17.8999C151.763 17.7441 151.461 17.6662 151.117 17.6662C150.749 17.6662 150.426 17.7557 150.147 17.9347C149.869 18.1103 149.652 18.3423 149.496 18.6307C149.343 18.9157 149.266 19.2289 149.262 19.5703V20.6293C149.262 21.0734 149.343 21.4545 149.506 21.7727C149.668 22.0876 149.895 22.3295 150.187 22.4986C150.479 22.6643 150.82 22.7472 151.211 22.7472C151.473 22.7472 151.71 22.7107 151.922 22.6378C152.134 22.5616 152.318 22.4505 152.474 22.3047C152.63 22.1589 152.747 21.9782 152.827 21.7628L154.507 21.9517C154.401 22.3958 154.199 22.7836 153.901 23.1151C153.606 23.4432 153.228 23.6984 152.767 23.8807C152.307 24.0597 151.78 24.1491 151.186 24.1491Z" fill="#3E3F40" />
          <defs>
            <clipPath id="clip0_2803_68992">
              <rect width="24" height="24" fill="white" transform="translate(70.5 7)" />
            </clipPath>
          </defs>
        </svg>
      </div >}

      {(currdeviceinfo.recordingStatus === "start" || currdeviceinfo.recordingStatus === "pause" || currdeviceinfo.recordingStatus === "resume") && <div onClick={() => recordParticipant("stop")}>
        <svg width="226" height="38" viewBox="0 0 226 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="226" height="38" rx="6" fill="#DE003D" />
          <g clip-path="url(#clip0_2803_28558)">
            <path d="M57.9997 13.334C61.1263 13.334 63.6663 15.874 63.6663 19.0007C63.6663 22.1273 61.1263 24.6673 57.9997 24.6673C54.873 24.6673 52.333 22.1273 52.333 19.0007C52.333 15.874 54.873 13.334 57.9997 13.334ZM57.9997 12.334C54.3197 12.334 51.333 15.3207 51.333 19.0007C51.333 22.6807 54.3197 25.6673 57.9997 25.6673C61.6797 25.6673 64.6663 22.6807 64.6663 19.0007C64.6663 15.3207 61.6797 12.334 57.9997 12.334Z" fill="white" />
            <path d="M57.9997 21.6673C59.4724 21.6673 60.6663 20.4734 60.6663 19.0007C60.6663 17.5279 59.4724 16.334 57.9997 16.334C56.5269 16.334 55.333 17.5279 55.333 19.0007C55.333 20.4734 56.5269 21.6673 57.9997 21.6673Z" fill="white" />
          </g>
          <path d="M78.5376 16.6172C78.4912 16.183 78.2957 15.8449 77.951 15.603C77.6096 15.361 77.1655 15.2401 76.6186 15.2401C76.2341 15.2401 75.9044 15.2981 75.6293 15.4141C75.3542 15.5301 75.1437 15.6875 74.9979 15.8864C74.852 16.0852 74.7775 16.3123 74.7741 16.5675C74.7741 16.7796 74.8222 16.9635 74.9183 17.1193C75.0178 17.2751 75.152 17.4077 75.321 17.517C75.4901 17.6231 75.6773 17.7126 75.8828 17.7855C76.0883 17.8584 76.2955 17.9197 76.5043 17.9695L77.4588 18.2081C77.8433 18.2976 78.2128 18.4186 78.5675 18.571C78.9254 18.7235 79.2453 18.9157 79.527 19.1477C79.812 19.3797 80.0374 19.6598 80.2031 19.9879C80.3688 20.3161 80.4517 20.7005 80.4517 21.1413C80.4517 21.7379 80.2992 22.2633 79.9943 22.7173C79.6894 23.1681 79.2486 23.5211 78.6719 23.7763C78.0985 24.0282 77.4041 24.1541 76.5888 24.1541C75.7966 24.1541 75.1089 24.0315 74.5256 23.7862C73.9455 23.541 73.4915 23.183 73.1634 22.7124C72.8385 22.2417 72.6629 21.6683 72.6364 20.9922H74.451C74.4775 21.3468 74.5869 21.6418 74.7791 21.8771C74.9714 22.1125 75.2216 22.2881 75.5298 22.4041C75.8414 22.5201 76.1894 22.5781 76.5739 22.5781C76.9749 22.5781 77.3262 22.5185 77.6278 22.3991C77.9328 22.2765 78.1714 22.1075 78.3438 21.892C78.5161 21.6733 78.6039 21.4181 78.6072 21.1264C78.6039 20.8613 78.526 20.6425 78.3736 20.4702C78.2211 20.2945 78.0073 20.1487 77.7322 20.0327C77.4605 19.9134 77.1423 19.8073 76.7777 19.7145L75.6193 19.4162C74.7808 19.2008 74.1179 18.8743 73.6307 18.4368C73.1468 17.996 72.9048 17.411 72.9048 16.6818C72.9048 16.0819 73.0672 15.5566 73.392 15.1058C73.7202 14.6551 74.166 14.3054 74.7294 14.0568C75.2929 13.8049 75.9309 13.679 76.6435 13.679C77.366 13.679 77.9991 13.8049 78.5426 14.0568C79.0895 14.3054 79.5187 14.6518 79.8303 15.0959C80.1418 15.5367 80.3026 16.0438 80.3125 16.6172H78.5376ZM85.8297 16.3636V17.7557H81.4398V16.3636H85.8297ZM82.5236 14.5341H84.3233V21.7031C84.3233 21.9451 84.3598 22.1307 84.4327 22.2599C84.5089 22.3859 84.6084 22.4721 84.731 22.5185C84.8536 22.5649 84.9895 22.5881 85.1387 22.5881C85.2514 22.5881 85.3541 22.5798 85.4469 22.5632C85.543 22.5466 85.6159 22.5317 85.6657 22.5185L85.9689 23.9254C85.8728 23.9586 85.7353 23.995 85.5563 24.0348C85.3806 24.0746 85.1652 24.0978 84.91 24.1044C84.4592 24.1177 84.0532 24.0497 83.6919 23.9006C83.3307 23.7481 83.044 23.5128 82.8319 23.1946C82.623 22.8764 82.5203 22.4787 82.5236 22.0014V14.5341ZM90.5838 24.1491C89.8381 24.1491 89.1918 23.9851 88.6449 23.657C88.098 23.3288 87.6738 22.8698 87.3722 22.2798C87.0739 21.6899 86.9247 21.0005 86.9247 20.2116C86.9247 19.4228 87.0739 18.7318 87.3722 18.1385C87.6738 17.5452 88.098 17.0845 88.6449 16.7564C89.1918 16.4283 89.8381 16.2642 90.5838 16.2642C91.3295 16.2642 91.9759 16.4283 92.5227 16.7564C93.0696 17.0845 93.4922 17.5452 93.7905 18.1385C94.0921 18.7318 94.2429 19.4228 94.2429 20.2116C94.2429 21.0005 94.0921 21.6899 93.7905 22.2798C93.4922 22.8698 93.0696 23.3288 92.5227 23.657C91.9759 23.9851 91.3295 24.1491 90.5838 24.1491ZM90.5938 22.7074C90.9981 22.7074 91.3362 22.5964 91.608 22.3743C91.8797 22.1489 92.0819 21.8473 92.2145 21.4695C92.3504 21.0916 92.4183 20.6707 92.4183 20.2067C92.4183 19.7393 92.3504 19.3168 92.2145 18.9389C92.0819 18.5578 91.8797 18.2545 91.608 18.0291C91.3362 17.8037 90.9981 17.6911 90.5938 17.6911C90.1795 17.6911 89.8348 17.8037 89.5597 18.0291C89.2879 18.2545 89.084 18.5578 88.9482 18.9389C88.8156 19.3168 88.7493 19.7393 88.7493 20.2067C88.7493 20.6707 88.8156 21.0916 88.9482 21.4695C89.084 21.8473 89.2879 22.1489 89.5597 22.3743C89.8348 22.5964 90.1795 22.7074 90.5938 22.7074ZM95.7704 26.8636V16.3636H97.5403V17.6264H97.6447C97.7375 17.4408 97.8684 17.2436 98.0375 17.0348C98.2065 16.8227 98.4352 16.642 98.7235 16.4929C99.0119 16.3404 99.3798 16.2642 99.8272 16.2642C100.417 16.2642 100.949 16.415 101.423 16.7166C101.9 17.0149 102.278 17.4574 102.557 18.044C102.838 18.6274 102.979 19.3433 102.979 20.1918C102.979 21.0303 102.842 21.7429 102.567 22.3295C102.291 22.9162 101.917 23.3636 101.443 23.6719C100.969 23.9801 100.432 24.1342 99.8322 24.1342C99.3947 24.1342 99.0318 24.0613 98.7434 23.9155C98.4551 23.7696 98.2231 23.594 98.0474 23.3885C97.8751 23.1797 97.7408 22.9825 97.6447 22.7969H97.5701V26.8636H95.7704ZM97.5353 20.1818C97.5353 20.6757 97.6049 21.1082 97.7441 21.4794C97.8867 21.8506 98.0905 22.1406 98.3556 22.3494C98.6241 22.5549 98.9489 22.6577 99.3301 22.6577C99.7278 22.6577 100.061 22.5516 100.329 22.3395C100.598 22.1241 100.8 21.8307 100.936 21.4595C101.075 21.085 101.145 20.6591 101.145 20.1818C101.145 19.7079 101.077 19.2869 100.941 18.919C100.805 18.5511 100.603 18.2628 100.334 18.054C100.066 17.8452 99.7311 17.7408 99.3301 17.7408C98.9456 17.7408 98.6191 17.8419 98.3507 18.044C98.0822 18.2462 97.8784 18.5296 97.7392 18.8942C97.6033 19.2588 97.5353 19.688 97.5353 20.1818ZM108.073 24V13.8182H111.891C112.673 13.8182 113.329 13.9541 113.86 14.2259C114.393 14.4976 114.796 14.8788 115.068 15.3693C115.343 15.8565 115.48 16.425 115.48 17.0746C115.48 17.7275 115.341 18.2943 115.063 18.7749C114.788 19.2521 114.382 19.6217 113.845 19.8835C113.308 20.142 112.648 20.2713 111.866 20.2713H109.146V18.7401H111.617C112.075 18.7401 112.449 18.6771 112.741 18.5511C113.033 18.4219 113.248 18.2346 113.387 17.9893C113.53 17.7408 113.601 17.4358 113.601 17.0746C113.601 16.7133 113.53 16.4051 113.387 16.1499C113.245 15.8913 113.028 15.6958 112.736 15.5632C112.444 15.4273 112.068 15.3594 111.607 15.3594H109.917V24H108.073ZM113.333 19.3864L115.853 24H113.795L111.319 19.3864H113.333ZM120.37 24.1491C119.604 24.1491 118.943 23.9901 118.386 23.6719C117.833 23.3504 117.407 22.8963 117.108 22.3097C116.81 21.7197 116.661 21.0253 116.661 20.2266C116.661 19.4411 116.81 18.7517 117.108 18.1584C117.41 17.5618 117.831 17.0978 118.371 16.7663C118.912 16.4316 119.546 16.2642 120.275 16.2642C120.746 16.2642 121.19 16.3404 121.608 16.4929C122.029 16.642 122.4 16.8741 122.721 17.1889C123.046 17.5038 123.301 17.9048 123.487 18.392C123.673 18.8759 123.765 19.4527 123.765 20.1222V20.674H117.506V19.4609H122.04C122.037 19.1162 121.962 18.8097 121.817 18.5412C121.671 18.2694 121.467 18.0556 121.205 17.8999C120.947 17.7441 120.645 17.6662 120.3 17.6662C119.932 17.6662 119.609 17.7557 119.331 17.9347C119.052 18.1103 118.835 18.3423 118.68 18.6307C118.527 18.9157 118.449 19.2289 118.446 19.5703V20.6293C118.446 21.0734 118.527 21.4545 118.689 21.7727C118.852 22.0876 119.079 22.3295 119.371 22.4986C119.662 22.6643 120.004 22.7472 120.395 22.7472C120.657 22.7472 120.894 22.7107 121.106 22.6378C121.318 22.5616 121.502 22.4505 121.657 22.3047C121.813 22.1589 121.931 21.9782 122.01 21.7628L123.691 21.9517C123.585 22.3958 123.383 22.7836 123.084 23.1151C122.789 23.4432 122.412 23.6984 121.951 23.8807C121.49 24.0597 120.963 24.1491 120.37 24.1491ZM128.619 24.1491C127.857 24.1491 127.202 23.9818 126.655 23.647C126.112 23.3123 125.692 22.8499 125.397 22.2599C125.106 21.6667 124.96 20.9839 124.96 20.2116C124.96 19.4361 125.109 18.7517 125.407 18.1584C125.706 17.5618 126.127 17.0978 126.67 16.7663C127.217 16.4316 127.863 16.2642 128.609 16.2642C129.229 16.2642 129.777 16.3786 130.255 16.6072C130.735 16.8326 131.118 17.1525 131.403 17.5668C131.688 17.9777 131.85 18.4583 131.89 19.0085H130.17C130.1 18.6406 129.935 18.334 129.673 18.0888C129.414 17.8402 129.068 17.7159 128.634 17.7159C128.266 17.7159 127.943 17.8153 127.664 18.0142C127.386 18.2098 127.169 18.4915 127.013 18.8594C126.861 19.2273 126.784 19.6681 126.784 20.1818C126.784 20.7022 126.861 21.1496 127.013 21.5241C127.166 21.8954 127.379 22.1821 127.654 22.3842C127.933 22.5831 128.259 22.6825 128.634 22.6825C128.899 22.6825 129.136 22.6328 129.345 22.5334C129.557 22.4306 129.734 22.2831 129.877 22.0909C130.019 21.8987 130.117 21.665 130.17 21.3899H131.89C131.847 21.9302 131.688 22.4091 131.413 22.8267C131.138 23.241 130.763 23.5658 130.289 23.8011C129.815 24.0331 129.259 24.1491 128.619 24.1491ZM136.699 24.1491C135.953 24.1491 135.307 23.9851 134.76 23.657C134.213 23.3288 133.789 22.8698 133.487 22.2798C133.189 21.6899 133.04 21.0005 133.04 20.2116C133.04 19.4228 133.189 18.7318 133.487 18.1385C133.789 17.5452 134.213 17.0845 134.76 16.7564C135.307 16.4283 135.953 16.2642 136.699 16.2642C137.445 16.2642 138.091 16.4283 138.638 16.7564C139.185 17.0845 139.607 17.5452 139.906 18.1385C140.207 18.7318 140.358 19.4228 140.358 20.2116C140.358 21.0005 140.207 21.6899 139.906 22.2798C139.607 22.8698 139.185 23.3288 138.638 23.657C138.091 23.9851 137.445 24.1491 136.699 24.1491ZM136.709 22.7074C137.113 22.7074 137.451 22.5964 137.723 22.3743C137.995 22.1489 138.197 21.8473 138.33 21.4695C138.466 21.0916 138.534 20.6707 138.534 20.2067C138.534 19.7393 138.466 19.3168 138.33 18.9389C138.197 18.5578 137.995 18.2545 137.723 18.0291C137.451 17.8037 137.113 17.6911 136.709 17.6911C136.295 17.6911 135.95 17.8037 135.675 18.0291C135.403 18.2545 135.199 18.5578 135.063 18.9389C134.931 19.3168 134.865 19.7393 134.865 20.2067C134.865 20.6707 134.931 21.0916 135.063 21.4695C135.199 21.8473 135.403 22.1489 135.675 22.3743C135.95 22.5964 136.295 22.7074 136.709 22.7074ZM141.886 24V16.3636H143.631V17.6364H143.71C143.849 17.1955 144.088 16.8558 144.426 16.6172C144.768 16.3752 145.157 16.2543 145.594 16.2543C145.694 16.2543 145.805 16.2592 145.928 16.2692C146.054 16.2758 146.158 16.2874 146.241 16.304V17.9595C146.165 17.933 146.044 17.9098 145.878 17.8899C145.715 17.8667 145.558 17.8551 145.406 17.8551C145.077 17.8551 144.782 17.9264 144.521 18.0689C144.262 18.2081 144.058 18.402 143.909 18.6506C143.76 18.8991 143.685 19.1858 143.685 19.5107V24H141.886ZM149.956 24.1342C149.356 24.1342 148.819 23.9801 148.345 23.6719C147.871 23.3636 147.497 22.9162 147.221 22.3295C146.946 21.7429 146.809 21.0303 146.809 20.1918C146.809 19.3433 146.948 18.6274 147.226 18.044C147.508 17.4574 147.888 17.0149 148.365 16.7166C148.842 16.415 149.374 16.2642 149.961 16.2642C150.408 16.2642 150.776 16.3404 151.064 16.4929C151.353 16.642 151.581 16.8227 151.751 17.0348C151.92 17.2436 152.05 17.4408 152.143 17.6264H152.218V13.8182H154.023V24H152.253V22.7969H152.143C152.05 22.9825 151.916 23.1797 151.741 23.3885C151.565 23.594 151.333 23.7696 151.045 23.9155C150.756 24.0613 150.393 24.1342 149.956 24.1342ZM150.458 22.6577C150.839 22.6577 151.164 22.5549 151.432 22.3494C151.701 22.1406 151.905 21.8506 152.044 21.4794C152.183 21.1082 152.253 20.6757 152.253 20.1818C152.253 19.688 152.183 19.2588 152.044 18.8942C151.908 18.5296 151.706 18.2462 151.437 18.044C151.172 17.8419 150.846 17.7408 150.458 17.7408C150.057 17.7408 149.722 17.8452 149.454 18.054C149.185 18.2628 148.983 18.5511 148.847 18.919C148.711 19.2869 148.643 19.7079 148.643 20.1818C148.643 20.6591 148.711 21.085 148.847 21.4595C148.986 21.8307 149.19 22.1241 149.459 22.3395C149.73 22.5516 150.064 22.6577 150.458 22.6577ZM155.94 24V16.3636H157.74V24H155.94ZM156.845 15.2798C156.56 15.2798 156.315 15.1854 156.109 14.9964C155.904 14.8042 155.801 14.5739 155.801 14.3054C155.801 14.0336 155.904 13.8033 156.109 13.6143C156.315 13.4221 156.56 13.326 156.845 13.326C157.134 13.326 157.379 13.4221 157.581 13.6143C157.786 13.8033 157.889 14.0336 157.889 14.3054C157.889 14.5739 157.786 14.8042 157.581 14.9964C157.379 15.1854 157.134 15.2798 156.845 15.2798ZM161.39 19.5256V24H159.591V16.3636H161.311V17.6612H161.4C161.576 17.2337 161.856 16.8939 162.241 16.642C162.628 16.3902 163.107 16.2642 163.677 16.2642C164.204 16.2642 164.663 16.3769 165.055 16.6023C165.449 16.8277 165.754 17.1541 165.969 17.5817C166.188 18.0092 166.296 18.5279 166.292 19.1378V24H164.493V19.4162C164.493 18.9058 164.36 18.5064 164.095 18.218C163.833 17.9297 163.47 17.7855 163.006 17.7855C162.691 17.7855 162.411 17.8551 162.166 17.9943C161.924 18.1302 161.733 18.3274 161.594 18.5859C161.458 18.8445 161.39 19.1577 161.39 19.5256ZM171.443 27.0227C170.797 27.0227 170.242 26.9349 169.778 26.7592C169.314 26.5869 168.941 26.3549 168.659 26.0632C168.377 25.7715 168.182 25.4484 168.072 25.0938L169.693 24.701C169.766 24.8501 169.872 24.9976 170.011 25.1435C170.15 25.2926 170.338 25.4152 170.573 25.5114C170.812 25.6108 171.112 25.6605 171.473 25.6605C171.983 25.6605 172.406 25.5362 172.741 25.2876C173.075 25.0424 173.243 24.638 173.243 24.0746V22.6278H173.153C173.06 22.8134 172.925 23.004 172.746 23.1996C172.57 23.3951 172.336 23.5592 172.045 23.6918C171.756 23.8243 171.393 23.8906 170.956 23.8906C170.369 23.8906 169.837 23.7531 169.36 23.478C168.886 23.1996 168.508 22.7853 168.226 22.2351C167.948 21.6816 167.809 20.9889 167.809 20.157C167.809 19.3184 167.948 18.6108 168.226 18.0341C168.508 17.4541 168.888 17.0149 169.365 16.7166C169.842 16.415 170.374 16.2642 170.961 16.2642C171.408 16.2642 171.776 16.3404 172.064 16.4929C172.356 16.642 172.588 16.8227 172.76 17.0348C172.933 17.2436 173.064 17.4408 173.153 17.6264H173.253V16.3636H175.028V24.1243C175.028 24.7772 174.872 25.3175 174.56 25.745C174.249 26.1726 173.823 26.4924 173.282 26.7045C172.742 26.9167 172.129 27.0227 171.443 27.0227ZM171.458 22.4787C171.839 22.4787 172.164 22.3859 172.432 22.2003C172.701 22.0147 172.905 21.7479 173.044 21.3999C173.183 21.0518 173.253 20.6342 173.253 20.147C173.253 19.6664 173.183 19.2455 173.044 18.8842C172.908 18.523 172.706 18.2429 172.437 18.044C172.172 17.8419 171.846 17.7408 171.458 17.7408C171.057 17.7408 170.722 17.8452 170.454 18.054C170.185 18.2628 169.983 18.5495 169.847 18.9141C169.711 19.2753 169.643 19.6863 169.643 20.147C169.643 20.6143 169.711 21.0237 169.847 21.375C169.986 21.723 170.19 21.9948 170.459 22.1903C170.73 22.3826 171.064 22.4787 171.458 22.4787Z" fill="white" />
          <defs>
            <clipPath id="clip0_2803_28558">
              <rect width="16" height="16" fill="white" transform="translate(50 11)" />
            </clipPath>
          </defs>
        </svg>
      </div>}
    </div>
  );

  const cccontent = (
    <div className="moreoptionpop">
      <div className="profileAreaPopover">
        <div className="userDetails">
          <ul className="langSelection langnoscroll">
            <li>Close captions
              <span>
                <Popover content={content} placement="rightBottom"
                  trigger="click"
                  overlayClassName="morecochat"
                >{ccLang === "ar" ? "Arabic" : ccLang === "bn" ? "Bengali" : ccLang === "en" ? "English" : ccLang === "fr" ? "French" : ccLang === "hi" ? "Hindi" : ccLang === "ja" ? "Japanese" : ccLang === "ko" ? "Korean" : ccLang === "pl" ? "Polish" : ccLang === "pt" ? "Portuguese" : ccLang === "ro" ? "Romanian" : ccLang === "ru" ? "Russian" : ccLang === "es" ? "Spanish" : ccLang === "ta" ? "Tamil" : ccLang === "te" ? "Telugu" : ccLang === "ur" ? "Urdu" : "English"}
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
                    <path d="M0.847119 11.6649C0.654719 11.6649 0.462319 11.5917 0.315919 11.4442C0.0234195 11.1512 0.0244193 10.6766 0.317919 10.3837L4.18222 6.53116C4.32432 6.38956 4.40242 6.20006 4.40242 5.99896C4.40242 5.79876 4.32432 5.61026 4.18222 5.46866L0.31752 1.61516C0.0245197 1.32216 0.0236196 0.84756 0.31602 0.55466C0.60802 0.26076 1.08312 0.26076 1.37702 0.55266L5.24132 4.40616C5.66712 4.83096 5.90192 5.39636 5.90242 5.99896C5.90292 6.60156 5.66802 7.16696 5.24132 7.59366L1.37662 11.4462C1.23062 11.5917 1.03852 11.6649 0.847119 11.6649Z" fill="#000" />
                  </svg>
                </Popover>
              </span>
            </li>
            <li style={{ color: "#575CFF" }} onClick={backToReset}>Reset to default</li>
            <li onClick={openTranscription}>View Transcript</li>
          </ul>
        </div>
      </div>
    </div>
  );

  const endMeetingHost = () => {
    const {meetingDetails}:any=store.getState().meetingReducer;
    const {recordTransript}:any=store.getState().closeCaption;
    sipCallEnd();
    videoCallService.endMeeting("endall");
    if (recordPopup) {
      store.dispatch({
        type: meetActionTypes.RECORD_POPUP,
        payload: { recordPopup: false }
      })
    }
    // let data:any={};
    // data.meeting_id=meetingDetails.meetingId;
    // data.transcript=recordTransript;
    // MeetServices.post(data,`/insert_videomeet_record_transcript`).then((res:any)=>{
    //   console.log("transcript inserted successfully")
    // })
    // .catch((err:any)=>{
    //       console.log("err",err)
    // })
  }

  const setRecModal = () => {
    store.dispatch({
      type: meetActionTypes.RECORD_POPUP,
      payload: { recordPopup: false }
    })
  }

  const closeEndModal = () => {
    setEndModal(false);
  }

  const sendScreenSize=()=>{
    let canvasAgent:any= document.getElementById("canvaagent");
    if(canvasAgent  && annotationEnable && sharingStatus){let mainBoard:any=document.getElementById('screenShareVideo');
    canvasAgent.height=mainBoard?.offsetHeight;
    canvasAgent.width=mainBoard?.offsetWidth;
    let data:any={};
    data.width=mainBoard.offsetWidth;
    data.height=mainBoard.offsetHeight;
    data.conId=remotedev[0]?.conId;
    data.deviceid=remotedev[0]?.deviceid;
    videoCallService.updateScreenSize(data);
    drawLineAgent(annotation);
  }
  }

  useEffect(()=>{
if(annotationEnable && sharingStatus){
      const remoteVideo:any = document.getElementById('screenShareVideo');
    setRemoteVideo(remoteVideo.offsetWidth,remoteVideo.offsetHeight);
    sendScreenSize();
     }
},[screenShareVideo?.offsetHeight,screenShareVideo?.offsetWidth])

const setAnnotateOptions=(opt:any)=>{
setAnnotateOpt(opt);
setOpt(opt);

}





useLayoutEffect(()=>{
  const chatStore = GetItemFromStorage("chat") || "";
  if (chatStore) {
   const parseChat: any = JSON.parse(chatStore);
   if (meetingDetails?.meetingDetails?.uuid && parseChat && parseChat[meetingDetails.meetingDetails.uuid] && parseChat[meetingDetails.meetingDetails.uuid]["private"] !== undefined) {
     Object.values(parseChat[meetingDetails.meetingDetails.uuid]["private"]).map((value: any) => {
       publicChat = publicChat + value.count;
       setCount(publicChat)
       return value;
     });
   }

 }
},[chatConvo?.length,chatConvo,JSON.stringify(messageReducer),JSON.stringify(chatConvo)])



  return (
    <>

      <div className={styles.videomaindiv}>

        {sharingStatus &&  <div className="sharescreeninfomain">
          <div className="sharescreeninfo">
         <div className="sharescreenleft">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.0191 3.00891C2.8417 3.00891 3.51477 2.33584 3.51477 1.51324C3.51477 0.690645 2.8417 0.0175781 2.0191 0.0175781C1.1965 0.0175781 0.523438 0.690645 0.523438 1.51324C0.523438 2.33584 1.1965 3.00891 2.0191 3.00891ZM2.0191 4.50458C1.1965 4.50458 0.523438 5.17764 0.523438 6.00025C0.523438 6.82284 1.1965 7.49591 2.0191 7.49591C2.8417 7.49591 3.51477 6.82284 3.51477 6.00025C3.51477 5.17764 2.8417 4.50458 2.0191 4.50458ZM0.523438 10.4872C0.523438 9.66464 1.1965 8.99158 2.0191 8.99158C2.8417 8.99158 3.51477 9.66464 3.51477 10.4872C3.51477 11.3098 2.8417 11.9829 2.0191 11.9829C1.1965 11.9829 0.523438 11.3098 0.523438 10.4872Z" fill="black" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.98137 3.00891C7.80397 3.00891 8.47704 2.33584 8.47704 1.51324C8.47704 0.690645 7.80397 0.0175781 6.98137 0.0175781C6.15877 0.0175781 5.4857 0.690645 5.4857 1.51324C5.4857 2.33584 6.15877 3.00891 6.98137 3.00891ZM6.98137 4.50458C6.15877 4.50458 5.4857 5.17764 5.4857 6.00025C5.4857 6.82284 6.15877 7.49591 6.98137 7.49591C7.80397 7.49591 8.47704 6.82284 8.47704 6.00025C8.47704 5.17764 7.80397 4.50458 6.98137 4.50458ZM5.4857 10.4872C5.4857 9.66464 6.15877 8.99158 6.98137 8.99158C7.80397 8.99158 8.47704 9.66464 8.47704 10.4872C8.47704 11.3098 7.80397 11.9829 6.98137 11.9829C6.15877 11.9829 5.4857 11.3098 5.4857 10.4872Z" fill="black" />
              </svg>
              {!annotationEnable ? "Your screen is being shared" : ` You are controlling ${remotedev[0]?.name} screen`}
              <svg xmlns="http://www.w3.org/2000/svg" width="3" height="12" viewBox="0 0 3 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.50006 3.00891C2.32266 3.00891 2.99573 2.33584 2.99573 1.51324C2.99573 0.690645 2.32266 0.0175781 1.50006 0.0175781C0.677461 0.0175781 0.00439453 0.690645 0.00439453 1.51324C0.00439453 2.33584 0.677461 3.00891 1.50006 3.00891ZM1.50006 4.50458C0.677461 4.50458 0.00439453 5.17764 0.00439453 6.00024C0.00439453 6.82284 0.677461 7.49591 1.50006 7.49591C2.32266 7.49591 2.99573 6.82284 2.99573 6.00024C2.99573 5.17764 2.32266 4.50458 1.50006 4.50458ZM0.00439453 10.4872C0.00439453 9.66464 0.677461 8.99158 1.50006 8.99158C2.32266 8.99158 2.99573 9.66464 2.99573 10.4872C2.99573 11.3098 2.32266 11.9829 1.50006 11.9829C0.677461 11.9829 0.00439453 11.3098 0.00439453 10.4872Z" fill="black" />
              </svg>
            </div>
          
           {<div className="sharescreenright" onClick={stopShare}>
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1.16413 0.671875C0.611964 0.671875 0.164551 1.11929 0.164551 1.67146V10.328C0.164551 10.8798 0.611964 11.3276 1.16413 11.3276C1.7163 11.3276 2.16372 10.8798 2.16372 10.328V1.67146C2.16372 1.11929 1.7163 0.671875 1.16413 0.671875Z" fill="white" />
                <path d="M5.83539 0.671875C5.28355 0.671875 4.8358 1.11929 4.8358 1.67146V10.328C4.8358 10.8798 5.28355 11.3276 5.83539 11.3276C6.38723 11.3276 6.83497 10.8798 6.83497 10.328V1.67146C6.83497 1.11929 6.38723 0.671875 5.83539 0.671875Z" fill="white" />
              </svg>
              {!annotationEnable ? "Stop Co-browse" : "Stop share"}
            </div>}
          </div>
        </div>}



        <div className={styles.videosection}>
          {sharingStatus && <div className={styles.videoshareleft} style={{ width: "368px" }}>
            {


              activeParticipantList.map((elem: any) => {
                if (!elem.isScreenshare) {
                  return (
                    <VideoShareLeftBar elem={elem} type={"agent"}/>
                  )
                }
              })
            }

          </div>}
          <div className={styles.videoleft} style={{ width: (componentState !== "" && fullScreenAgent && !sharingStatus) ? "calc(100% - 386px)" : annotationEnable ? "calc(100% - 386px)"  :(componentState === "") ? "100%" : (fullScreenAgent && sharingStatus && !annotationEnable) ? "calc(100% - 744px)" : "calc(100% - 744px)" }}>
          {ccBtns && <CloseCaptionCommon type={"customer"+ styles.agentcaptions} />}
            <div className={styles.videotopbar}>
              <div className={styles.lefts}>
                <div className={styles.lefticoncont}>
                <ul>

                {!remotedev[0]?.mute ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2" />
                        <g clip-path="url(#clip0_3269_55899)">
                          <path d="M16 19.2655C17.7148 19.2655 19.1104 17.87 19.1104 16.1551V9.58475C19.1104 7.86995 17.7149 6.47485 16 6.47485C14.2851 6.47485 12.8901 7.86985 12.8901 9.58475V16.1551C12.8901 17.8699 14.2851 19.2655 16 19.2655ZM14.3901 9.58475C14.3901 8.69705 15.1123 7.97485 16 7.97485C16.8882 7.97485 17.6104 8.69705 17.6104 9.58475V16.1551C17.6104 17.0433 16.8882 17.7655 16 17.7655C15.1123 17.7655 14.3901 17.0433 14.3901 16.1551V9.58475Z" fill="#000" />
                          <path d="M22.4404 16.055V13.0447C22.4404 12.6306 22.1045 12.2947 21.6904 12.2947C21.2763 12.2947 20.9404 12.6306 20.9404 13.0447V16.055C20.9404 18.6629 18.7246 20.785 16 20.785C13.2754 20.785 11.0601 18.6629 11.0601 16.055V13.0447C11.0601 12.6306 10.7242 12.2947 10.3101 12.2947C9.89596 12.2947 9.56006 12.6306 9.56006 13.0447V16.055C9.56006 19.2443 12.0518 21.8779 15.25 22.239V24.2244H11.8301C11.4712 24.2244 11.1802 24.5154 11.1802 24.8748C11.1802 25.2342 11.4712 25.5252 11.8301 25.5252H20.1699C20.5293 25.5252 20.8203 25.2342 20.8203 24.8748C20.8203 24.5154 20.5293 24.2244 20.1699 24.2244H16.75V22.239C19.9483 21.8779 22.4404 19.2442 22.4404 16.055Z" fill="#000" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3269_55899">
                            <rect width="24" height="24" fill="white" transform="translate(4 4)" />
                          </clipPath>
                        </defs>
                      </svg> :


                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="28" height="28" rx="6" fill="black" fill-opacity="0.2" />
                          <g clip-path="url(#clip0_3269_6851)">
                            <path d="M12.39 9.96498L15.61 13.195L16.36 13.955L17.07 14.665C17.1 14.495 17.11 14.325 17.11 14.155V7.58498C17.11 5.86498 15.71 4.47498 14 4.47498C12.28 4.47498 10.89 5.86498 10.89 7.58498V8.45498L11.64 9.20498L12.39 9.96498Z" fill="#DE003D" />
                            <path d="M20.44 14.055V11.045C20.44 10.625 20.1 10.295 19.69 10.295C19.28 10.295 18.94 10.625 18.94 11.045V14.055C18.94 14.775 18.77 15.455 18.46 16.065L19.56 17.175C20.12 16.255 20.44 15.195 20.44 14.055Z" fill="#DE003D" />
                            <path d="M22.68 22.775C22.53 22.925 22.34 22.995 22.15 22.995C21.96 22.995 21.77 22.925 21.62 22.775L17.87 19.015C16.98 19.675 15.92 20.115 14.75 20.245V22.225H18.18C18.54 22.225 18.83 22.515 18.83 22.875C18.83 23.235 18.54 23.525 18.18 23.525H9.83004C9.47004 23.525 9.18004 23.235 9.18004 22.875C9.18004 22.515 9.47004 22.225 9.83004 22.225H13.25V20.245C10.04 19.885 7.55004 17.245 7.55004 14.055V11.045C7.55004 10.625 7.89004 10.295 8.30004 10.295C8.71004 10.295 9.05004 10.625 9.05004 11.045V14.055C9.05004 16.665 11.27 18.785 14 18.785C15.04 18.785 16.01 18.475 16.81 17.945L15.65 16.775C15.17 17.085 14.61 17.255 14 17.255C12.28 17.255 10.89 15.865 10.89 14.155V11.995L5.32004 6.40498C5.03004 6.11498 5.03004 5.63498 5.32004 5.34498C5.61004 5.05498 6.09004 5.05498 6.38004 5.34498L22.68 21.715C22.97 22.005 22.97 22.485 22.68 22.775Z" fill="#DE003D" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3269_6851">
                              <rect x="2" y="2" width="24" height="24" rx="6" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      }
                  {!sharingStatus && <><li onClick={fullScreen}>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2"/>
                    <g clip-path="url(#clip0_3287_79449)">
                    <path d="M23.1678 8.83254C22.8748 8.53954 22.4002 8.53954 22.1073 8.83254L17.3973 13.542V10.3921C17.3973 9.97804 17.0614 9.64214 16.6473 9.64214C16.2332 9.64214 15.8973 9.97804 15.8973 10.3921V13.9487C15.8973 15.1362 16.8636 16.103 18.0516 16.103H21.6082C22.0223 16.103 22.3582 15.7671 22.3582 15.353C22.3582 14.9389 22.0223 14.603 21.6082 14.603H18.4573L23.1677 9.89304C23.4607 9.60004 23.4608 9.12544 23.1678 8.83254Z" fill="#F0F1F2"/>
                    <path d="M13.9491 15.897H10.392C9.97794 15.897 9.64204 16.2329 9.64204 16.647C9.64204 17.0611 9.97794 17.397 10.392 17.397H13.5429L8.83254 22.107C8.53954 22.4 8.53954 22.8746 8.83254 23.1675C8.97904 23.314 9.17094 23.3872 9.36284 23.3872C9.55474 23.3872 9.74664 23.314 9.89314 23.1675L14.6031 18.458V21.6079C14.6031 22.022 14.939 22.3579 15.3531 22.3579C15.7672 22.3579 16.1031 22.022 16.1031 21.6079V18.0513C16.1031 16.8638 15.1366 15.897 13.9491 15.897Z" fill="#F0F1F2"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3287_79449">
                    <rect width="24" height="24" fill="white" transform="translate(4 4)"/>
                    </clipPath>
                    </defs>
                    </svg>

                  </li>
                </>
                  }
                </ul>
                {currdeviceinfo.recordingStatus !=="stop" &&
                 <div className={styles.rectop}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M6.99967 0.333984C3.31967 0.333984 0.333008 3.32065 0.333008 7.00065C0.333008 10.6807 3.31967 13.6673 6.99967 13.6673C10.6797 13.6673 13.6663 10.6807 13.6663 7.00065C13.6663 3.32065 10.6797 0.333984 6.99967 0.333984ZM6.99967 9.67398C5.52634 9.67398 4.33301 8.48065 4.33301 7.00732C4.33301 5.53398 5.52634 4.34065 6.99967 4.34065C8.47301 4.34065 9.66634 5.53398 9.66634 7.00732C9.66634 8.48065 8.47301 9.67398 6.99967 9.67398Z" fill="#DE003D" />
                    </svg>
                    Rec
                    {/* <div>{formatTime(elapsedTime)}</div> */}
                    
                     {currdeviceinfo.recordingStatus === "pause" && <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" onClick={()=>record("resume")}>
                      <path d="M9.02623 4.61023L5.80091 2.75101L2.57559 0.891783C2.31569 0.745178 2.04247 0.671875 1.77592 0.671875C0.936269 0.671875 0.169922 1.34493 0.169922 2.27787V9.72144C0.169922 10.661 0.936269 11.3274 1.77592 11.3274C2.04247 11.3274 2.31569 11.2608 2.57559 11.1075L5.80091 9.2483L9.02623 7.38908C10.0991 6.76933 10.0991 5.22331 9.02623 4.61023Z" fill="white" />
                    </svg>}

                      {(currdeviceinfo.recordingStatus === "resume" || currdeviceinfo.recordingStatus === "start") && <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>record("pause")}>
                      <path d="M6.99983 1.33553C10.1252 1.33553 12.6641 3.8745 12.6641 6.9999C12.6641 10.1253 10.1252 12.6643 6.99983 12.6643C3.87446 12.6643 1.33552 10.1186 1.33552 6.9999C1.33552 3.88116 3.87446 1.33553 6.99983 1.33553ZM6.99983 0.335938C3.3147 0.335938 0.335938 3.31473 0.335938 6.9999C0.335938 10.6851 3.32136 13.6639 6.99983 13.6639C10.6783 13.6639 13.6637 10.6784 13.6637 6.9999C13.6637 3.32139 10.6783 0.335938 6.99983 0.335938Z" fill="white"/>
                      <path d="M5.00066 5.00071V8.99242C5.00066 9.36047 5.299 9.65881 5.66705 9.65881C6.0351 9.65881 6.33344 9.36047 6.33344 8.99242V5.00071C6.33344 4.63266 6.0351 4.33431 5.66705 4.33431C5.299 4.33431 5.00066 4.63266 5.00066 5.00071Z" fill="white"/>
                      <path d="M7.66622 5.00071V8.99242C7.66622 9.36047 7.96456 9.65881 8.33261 9.65881C8.70065 9.65881 8.99899 9.36047 8.99899 8.99242V5.00071C8.99899 4.63266 8.70065 4.33431 8.33261 4.33431C7.96456 4.33431 7.66622 4.63266 7.66622 5.00071Z" fill="white"/>
                      </svg>}
                      
                    
                     {<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" onClick={()=>record("stop")}>
                      <path d="M6.99967 0.333984C3.31781 0.333984 0.333008 3.31872 0.333008 7.00065C0.333008 10.6826 3.31781 13.6673 6.99967 13.6673C10.6815 13.6673 13.6663 10.6826 13.6663 7.00065C13.6663 3.31872 10.6815 0.333984 6.99967 0.333984ZM6.99967 12.6673C3.87507 12.6673 1.33301 10.1253 1.33301 7.00065C1.33301 3.87598 3.87507 1.33398 6.99967 1.33398C10.1243 1.33398 12.6663 3.87598 12.6663 7.00065C12.6663 10.1253 10.1243 12.6673 6.99967 12.6673Z" fill="white" />
                      <path d="M8.83234 4.50132H5.16701C4.79882 4.50132 4.50034 4.79979 4.50034 5.16798V8.83332C4.50034 9.20151 4.79882 9.49998 5.16701 9.49998H8.83234C9.20053 9.49998 9.49901 9.20151 9.49901 8.83332V5.16798C9.49901 4.79979 9.20053 4.50132 8.83234 4.50132Z" fill="white" />
                    </svg>}
                  </div>}
                  </div>
              </div>
              {(fullScreenAgent && !sharingStatus) && <div className={styles.rights} onClick={switchVideoStream}>
                <VideoSmall participantVideo={participantVideo} videoType={"agent"}/>
              </div>}
            </div>

            {!remotedev[0]?.video && !sharingStatus && (
              <><div className='novideoname forcustomer'>
                <div className="novideonametext">{remotedev[0]?.name?.toUpperCase().slice(0, 2)}</div>
              </div>
               </>        
            )}
            {sharingStatus ? (<div style={{position:"relative"}}><video
              id={"screenShareVideo"}
              playsInline
              autoPlay
              preload={"auto"} 
              className={styles.mainVideo}
              style={{ display: !remotedev.video ? "block" : "none",position:"absolute" }}
              ref={screenShareVideo}
            />
            {annotationEnable && sharingStatus && <canvas id="canvaagent"   className={(annotationEnable && opt ==="eraser") ? 'erraserhoverimg' : ''} style={{position:"absolute"}} onMouseDown={(e:any)=>moveClick(e)} onMouseUp={(e:any)=>moveRelease(e)} onMouseMove={(e:any)=>mouseMove(e)} onResize={sendScreenSize}></canvas>}
            </div>
            ) : (<video
              id={remotedev[0]?.conId}
              playsInline
              autoPlay
              preload={"auto"}
              className={styles.mainVideo}
              style={{ display: remotedev[0]?.video ? "block" : "none" }}
              ref={remVideo}
            />
            )}

            <h4 className={styles.username}>{remotedev[0]?.name}</h4>
          </div>
         {((!annotationEnable && !sharingStatus)||fullScreenAgent || (!annotationEnable && sharingStatus) || (annotationEnable && !sharingStatus)) && <div className={styles.videoright} >
            {componentState === "internalChat" ?
                            <ChatRightSideBar />
                          : componentState === "meetChat" ?  <VideoMeetingChat></VideoMeetingChat> : componentState === "meetTranscription" ? <MeetTranscription></MeetTranscription>:<ChatRightSideBar /> }
            </div> }
          
        </div>

        <div className={styles.videobottom}>

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="5" fill="black"/>
<path d="M19.017 6.25574L12.617 3.58874C12.4221 3.50759 12.2131 3.46582 12.002 3.46582C11.7909 3.46582 11.5819 3.50759 11.387 3.58874L4.987 6.25574C4.69496 6.37687 4.44535 6.5818 4.26969 6.84468C4.09403 7.10755 4.00018 7.41657 4 7.73274C4 14.3497 7.817 18.9227 11.383 20.4097C11.578 20.4906 11.7869 20.5322 11.998 20.5322C12.2091 20.5322 12.418 20.4906 12.613 20.4097C15.47 19.2187 20 15.1087 20 7.73274C20.0001 7.41703 19.9069 7.10833 19.732 6.84551C19.5571 6.58268 19.3083 6.37748 19.017 6.25574Z" fill="#00E79F"/>
<path d="M10.4885 9.98438H7.5V12.9727H10.4885V9.98438Z" fill="black"/>
<path d="M16.4999 8.60014V12.9727H13.4772V11.6218C13.4772 10.717 12.7432 9.98295 11.8379 9.98295H10.4873V6.96094H14.8605C15.7658 6.96094 16.4999 7.69496 16.4999 8.60014Z" fill="black"/>
<path d="M13.4768 12.9727V15.9609L10.4883 12.9727H13.4768Z" fill="black"/>
<path d="M13.4772 11.6219V12.9728L10.4873 9.98306H11.8379C12.7432 9.98306 13.4769 10.7167 13.4769 11.6219" fill="#F9FAFB"/>
</svg>

          <div className={styles.centerarea}>
            <ul>
            <Tooltip title="Mute">
              <li onClick={muteAudio} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {currdeviceinfo.mute ?
                  <div className={styles.imageBox}>
                    <div className={styles.imageInn}>
                      <img src={audion}/>
                    </div>
                    <div className={styles.hoverImg}>
                      <img src={audioh}/>
                    </div>
                  </div>
                  :

            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={audioa}></img>
            </div>
          </div>
                }
              </li>
              </Tooltip>
              <li onClick={muteVideo} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {!currdeviceinfo.video ?
                  <div className={styles.imageBox}>
                    <div className={styles.imageInn}>
                      <img src={videon}/>
                    </div>
                    <div className={styles.hoverImg}>
                      <img src={videoh}/>
                    </div>
                  </div>
                  :                  
            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={videoa}></img>
            </div>
          </div>
                  }
              </li>
              <li onClick={meetChat} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {componentState !== "meetChat" && !annotationEnable ? <div className={styles.imageBox}>
                {count > 0 ? <p className={styles.parcount}>{count}</p> : ""}
                  <div className={styles.imageInn}>
                    <img src={chatn} />
                  </div>
                  <div className={styles.hoverImg}>
                    <img src={chath} />
                  </div>
                </div>
                  :
                  annotationEnable ?  
                  <Tooltip title="Message is not available in Co-Browser mode">
                  <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={chatd}></img>
            </div>
          </div>  
          </Tooltip>:
                  
            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={chata}></img>
            </div>
          </div>}
              </li>
              {!_.isEmpty(vmSettings) && vmSettings["isScreenShare"] === 1 &&  <li className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>

                (!sharingStatus ? <div className={styles.imageBox} onClick={onshareScreen}>
                  <div className={styles.imageInn}>
                    <img src={sharen} />
                  </div>
                  <div className={styles.hoverImg}>
                    <img src={shareh} />
                  </div>
                </div>
                  :                  
            <div className={styles.imageBox}  onClick={onshareScreen}>
            <div className={styles.imageInn}>
              <img src={sharea}></img>
            </div>
          </div>
                  )
              </li>}
              <li className={vmTransfer ==="transfer_initiated" ? ` ${styles.disabledicon} ${styles.footerarrow}`: styles.footerarrow}>
                {!ccBtns ? <div className={styles.imageBox}>
                  <div className={styles.imageInn} onClick={startCloseCaption}>
                    <img src={ccn} />
                  </div>
                  <div className={styles.hoverImg} onClick={startCloseCaption}>
                    <img src={cch} />
                  </div>
                  <Popover content={cccontent}
                    trigger="click"
                    overlayClassName="morecochat"
                  >
                    <div className={styles.arrowlink}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                        <path d="M7.2766 3.93545C7.14833 3.93545 7.02007 3.88665 6.92247 3.78832L4.35347 1.21152C4.25907 1.11712 4.1334 1.06505 3.9996 1.06439C3.8658 1.06439 3.73987 1.11712 3.64513 1.21152L1.0768 3.78832C0.882132 3.98425 0.565065 3.98425 0.369799 3.78965C0.174132 3.59432 0.173532 3.27792 0.368466 3.08265L2.93713 0.505854C3.221 0.22132 3.59827 0.0644531 3.99967 0.0644531C4.40107 0.0651198 4.77833 0.221387 5.06187 0.505854L7.63086 3.08265C7.82586 3.27799 7.8252 3.59439 7.62953 3.78965C7.5322 3.88665 7.4042 3.93545 7.2766 3.93545Z" fill="white" />
                      </svg>
                    </div>
                  </Popover>

                </div>
                  :
                  <>
                    <div className={styles.imageBox}>
                      <img src={cca} onClick={startCloseCaption} />
                      <Popover content={cccontent}
                        trigger="click"
                        overlayClassName="morecochat"
                      >
                        <div className={styles.arrowlink}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                            <path d="M7.2766 3.93545C7.14833 3.93545 7.02007 3.88665 6.92247 3.78832L4.35347 1.21152C4.25907 1.11712 4.1334 1.06505 3.9996 1.06439C3.8658 1.06439 3.73987 1.11712 3.64513 1.21152L1.0768 3.78832C0.882132 3.98425 0.565065 3.98425 0.369799 3.78965C0.174132 3.59432 0.173532 3.27792 0.368466 3.08265L2.93713 0.505854C3.221 0.22132 3.59827 0.0644531 3.99967 0.0644531C4.40107 0.0651198 4.77833 0.221387 5.06187 0.505854L7.63086 3.08265C7.82586 3.27799 7.8252 3.59439 7.62953 3.78965C7.5322 3.88665 7.4042 3.93545 7.2766 3.93545Z" fill="white" />
                          </svg> </div> </Popover>
                    </div>
                  </>}
                  </li>
            {(!_.isEmpty(recSettings) && 'isVideo' in recSettings && recSettings?.isVideo === 1 ) && <li  className={vmTransfer === "transfer_initiated" ? styles.disabledicon : ""}>
              
              {currdeviceinfo.recordingStatus !== "stop" ? <div className={styles.imageBox} onClick={openRecModal}>
                <div className={styles.imageInn}>
                  <Popover content={contentrecord} trigger="click" open={recPop} overlayClassName="chatrecord">
                    <img src={recorda} />
                  </Popover>
                </div>
                <div className={styles.hoverImg}>
                  <Popover content={contentrecord} trigger="click" open={recPop}  overlayClassName="chatrecord">
                    <img src={recordh} />
                  </Popover>
                </div>

              </div>
                :
  
            <div className={styles.imageBox} onClick={openRecModal}>
            <div className={styles.imageInn}>
              <img src={recordn}></img>
            </div>
          </div>
     
}
         </li>}
              
              <li className={vmTransfer === "transfer_initiated" ? styles.disabledicon : ""}>
                {componentState !== "internalChat"  && !annotationEnable ?

                  <div className={styles.imageBox} onClick={openInternalChat}>
                    <div className={styles.imageInn}>
                      <img src={agentchatn} />
                    </div>
                    <div className={styles.hoverImg}>
                      <img src={agentchath} />
                    </div>
                  </div>
                  :
                  annotationEnable ?
                  <Tooltip title="Agent Assist is not available in Co-Browser mode">
                  <div className={styles.imageBox}>
                  <div className={styles.imageInn}>
                    <img src={agentchatad}></img>
                  </div>
                  </div>
                  </Tooltip>
                  :

            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={agentchata}></img>
            </div>
          </div>
                }
              </li>
            </ul>
          </div>
          <button onClick={end}>End</button>
        </div>
        {annotationEnable && sharingStatus &&  <Draggable bounds="parent"><div className="drawertools">

        <svg
xmlns="http://www.w3.org/2000/svg" width="12"
height="18"
viewBox="0 0 12 18"
fill="none">

<path fill-rule="evenodd" clip-rule="evenodd" d="M2.27817 4.51288C3.51207 4.51288 4.52167 3.50328 4.52167 2.26938C4.52167 1.03548 3.51207 0.0258789 2.27817 0.0258789C1.04427 0.0258789
 0.034668 1.03548 0.034668 2.26938C0.034668 3.50328 1.04427 4.51288 2.27817 4.51288ZM2.27817 6.75638C1.04427 6.75638 0.034668 7.76598 0.034668 8.99988C0.034668 10.2338 1.04427 11.2434 2.27817 11.2434C3.51207 11.2434 4.52167 10.2338 4.52167 8.99988C4.52167 7.76598
 3.51207 6.75638 2.27817 6.75638ZM0.034668 15.7304C0.034668 14.4965 1.04427 13.4869 2.27817 13.4869C3.51207 13.4869 4.52167 14.4965 4.52167 15.7304C4.52167 16.9643 3.51207 17.9739 2.27817 17.9739C1.04427 17.9739 0.034668 16.9643 0.034668 15.7304Z"
fill="#E3E4E5" />

<path
fill-rule="evenodd" clip-rule="evenodd" d="M9.72157 4.51288C10.9555 4.51288 11.9651 3.50328 11.9651 2.26938C11.9651 1.03548 10.9555 0.0258789 9.72157 0.0258789C8.48767 0.0258789
 7.47807 1.03548 7.47807 2.26938C7.47807 3.50328 8.48767 4.51288 9.72157 4.51288ZM9.72157 6.75638C8.48767 6.75638 7.47807 7.76598 7.47807 8.99988C7.47807 10.2338 8.48767 11.2434 9.72157 11.2434C10.9555 11.2434 11.9651 10.2338 11.9651 8.99988C11.9651 7.76598
 10.9555 6.75638 9.72157 6.75638ZM7.47807 15.7304C7.47807 14.4965 8.48767 13.4869 9.72157 13.4869C10.9555 13.4869 11.9651 14.4965 11.9651 15.7304C11.9651 16.9643 10.9555 17.9739 9.72157 17.9739C8.48767 17.9739 7.47807 16.9643 7.47807 15.7304Z"
fill="#E3E4E5" />

       </svg>

<div className={opt ==="" ? 'drawericon':opt ==="pencil" ? 'drawericon active' : "drawericon"} onClick={()=>setAnnotateOptions("pencil")}>

<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.63454 3.39329C8.56788 3.32662 8.48121 3.29329 8.38788 3.29329C8.30121 3.29329 8.21454 3.32662 8.15454 3.38662L0.974544 10.3466C0.847878 10.4733 0.767878 10.6466 0.767878 10.8266L0.741211 12.4133C0.741211 12.7866 1.03454 13.1 1.40788 13.1L2.99454 13.1266H3.00788C3.18121 13.1266 3.35454 13.06 3.48121 12.9333L10.6612 5.97329C10.7945 5.83995 10.8012 5.62662 10.6679 5.49329L8.63454 3.39329Z" fill="white"/>
<path d="M13.0679 2.70662L11.4879 1.07995C11.3545 0.946619 11.1812 0.879952 11.0079 0.879952L11.0145 0.873352C10.8479 0.873352 10.6812 0.933352 10.5479 1.06002L9.08788 2.47335C8.96121 2.59335 8.95454 2.80002 9.08121 2.92669L11.1412 5.05335C11.2012 5.12002 11.2879 5.15335 11.3745 5.15335C11.4612 5.15335 11.5345 5.12002 11.5945 5.06002L13.0545 3.64669C13.3212 3.39335 13.3279 2.96662 13.0679 2.70662Z" fill="white"/>
</svg>


<p>Draw</p>

</div>

<div className={opt ==="eraser" ? 'active drawericon':'drawericon'} onClick={()=>setAnnotateOptions("eraser")}>

<svg
xmlns="http://www.w3.org/2000/svg"
width="12"
height="12"
viewBox="0 0 12 12"
fill="none">

<path
d="M2.10845 5.44811L1.29532 6.25344C0.879986 6.66818 0.677452 7.13171 0.693786 7.63238C0.710052 8.11938 0.932719 8.58031 1.35592 9.00344L2.95099
 10.603C3.37479 11.023 3.83705 11.243 4.32405 11.2573C4.34032 11.2573 4.35725 11.258 4.37419 11.258C4.85339 11.258 5.29739 11.0562 5.69252 10.6603L6.51345 9.84718L2.10845 5.44811Z"
fill="white"
/>

<path
d="M10.8702 5.48264C11.1632 5.19098 11.3142 4.83291 11.3071 4.44684C11.2999 4.06858 11.143 3.71504 10.8539 3.42538L8.52772 1.09531C8.23672
 0.804309 7.88185 0.648709 7.50165 0.644775H7.48345C7.10392 0.644775 6.75365 0.795842 6.46979 1.08291L2.74645 4.80684L7.14619 9.20658L10.8702 5.48264Z"
fill="white"
/>

<path
d="M9.05972 10.8837H6.41485L6.16192 11.1344C6.07832 11.2178 5.98818 11.2844 5.89959 11.3551H9.05972C9.18992 11.3551 9.29539 11.2496
 9.29539 11.1194C9.29539 10.9892 9.18992 10.8837 9.05972 10.8837Z" 
fill="white"
/>

</svg>

<p>Eraser</p>

</div>

<div className={opt ==="undo" ? 'active drawericon':'drawericon'} onClick={()=>setAnnotateOptions("undo")}>

<svg
xmlns="http://www.w3.org/2000/svg"
width="12"
height="12"
viewBox="0 0 12 12"
fill="none">

<path
d="M6.62163 1.79273H3.52936L3.53243 1.31293C3.53436 1.02906 3.37909 0.76733 3.12909 0.633263C2.87909 0.499197 2.57569 0.512797 2.34003
 0.671663L0.884959 1.64693C0.674359 1.7882 0.547092 2.02453 0.545425 2.2778C0.543825 2.53173 0.667826 2.76933 0.876492 2.9132L2.31889 3.90866C2.44909 3.99853 2.60109 4.04406 2.75376 4.04406C2.87483 4.04406 2.99629 4.0148 3.10763 3.9568C3.35923 3.82593 3.51776
 3.5662 3.51976 3.283L3.52296 2.79273H6.62169C8.73496 2.79273 10.4544 4.51213 10.4544 6.6254C10.4544 8.73866 8.73496 10.4581 6.62169 10.4581H1.67636C1.40029 10.4581 1.17636 10.682 1.17636 10.9581C1.17636 11.2341 1.40029 11.4581 1.67636 11.4581H6.62169C9.28643
 11.4581 11.4544 9.29006 11.4544 6.6254C11.4544 3.96073 9.28629 1.79273 6.62163 1.79273Z"
fill="white"
/>

</svg>


<p>Undo</p>

</div>

<div className={opt ==="redo" ? 'active drawericon':'drawericon'} onClick={()=>setAnnotateOptions("redo")}>

<svg
xmlns="http://www.w3.org/2000/svg"
width="12"
height="12"
viewBox="0 0 12 12"
fill="none">

<path
d="M11.1151 1.64764L9.66034 0.671709C9.42501 0.513509 9.12161 0.499175 8.87094 0.633309C8.62094 0.767442 8.46568 1.02918 8.46761 1.31298L8.47068
 1.79278H5.37841C2.71334 1.79278 0.54541 3.96077 0.54541 6.62544C0.54541 9.29011 2.71341 11.4581 5.37841 11.4581H10.3234C10.5995 11.4581 10.8234 11.2342 10.8234 10.9581C10.8234 10.682 10.5995 10.4581 10.3234 10.4581H5.37841C3.26481 10.4581 1.54541 8.73871 1.54541
 6.62544C1.54541 4.51218 3.26481 2.79278 5.37841 2.79278H8.47714L8.48034 3.28304C8.48228 3.56624 8.64081 3.82604 8.89248 3.95684C9.00381 4.01477 9.12521 4.04411 9.24634 4.04411C9.39901 4.04411 9.55068 3.99851 9.68121 3.90871L11.1233 2.91457C11.3319 2.77071
 11.4559 2.53244 11.4543 2.27918C11.4527 2.02524 11.3257 1.78891 11.1151 1.64764Z"
fill="white"
/>

</svg>



<p>Redo</p>

</div>

<div className={opt ==="clear" ? 'active drawericon':'drawericon'} onClick={()=>setAnnotateOptions("clear")}>


 <svg
xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">

<path d="M4.91982 10.9561C4.64376 10.9561 4.41982 10.7322 4.41982 10.4561V4.74293C4.41982 4.46686 4.64376 4.24293 4.91982 4.24293C5.19589
 4.24293 5.41982 4.46686 5.41982 4.74293V10.4561C5.41982 10.7322 5.19589 10.9561 4.91982 10.9561Z"
fill="white" />

<path d="M7.07996 10.9561C6.80389 10.9561 6.57996 10.7322 6.57996 10.4561V4.74293C6.57996 4.46686 6.80389 4.24293 7.07996 4.24293C7.35602
 4.24293 7.57996 4.46686 7.57996 4.74293V10.4561C7.57996 10.7322 7.35602 10.9561 7.07996 10.9561Z"
fill="white" />

<path d="M11.4465 1.97633H8.81302V1.56973C8.81302 0.863995 8.25702 0.289795 7.57342 0.289795H4.41976C3.73616 0.289795 3.17982 0.863995 3.17982
 1.56973V1.97633H0.553223C0.277156 1.97633 0.0532227 2.20026 0.0532227 2.47633C0.0532227 2.75239 0.277156 2.97633 0.553223 2.97633H0.956089L1.46762 11.4054C1.54249 12.6977 2.61669 13.7101 3.91329 13.7101H8.07342C9.36902 13.7101 10.4491 12.6964 10.5324 11.4002L11.0443
 2.97639H11.4465C11.7226 2.97639 11.9465 2.75246 11.9465 2.47639C11.9465 2.20033 11.7226 1.97633 11.4465 1.97633ZM4.17989 1.56973C4.17989 1.41546 4.28762 1.28979 4.41982 1.28979H7.57349C7.70562 1.28979 7.81309 1.41546 7.81309 1.56973V1.97633H4.17996L4.17989
 1.56973ZM9.53436 11.3377C9.48489 12.1072 8.84296 12.7101 8.07342 12.7101H3.91329C3.14602 12.7101 2.50996 12.1117 2.46569 11.3461L1.95782 2.97633H10.0419L9.53436 11.3377Z"
fill="white" />

</svg>


<p>Clear</p>

</div>

</div></Draggable> }

        <Modal open={recordPopup} title={<><span>Record this meeting?</span></>}
          centered className="customModal sizessmall autocallmodal"
          closeIcon={<span className="icon__Close16" onClick={() => setRecModal()}> </span>}
          footer={[
            <Button className="buttonCancel" style={{ minWidth: "auto" }}
              onClick={endMeetingHost}
            >
              Leave Meeting
            </Button>,
            <Button type="primary" className="buttonSave "
              onClick={continueRecording}
            >
              Continue
            </Button>,
          ]}>
          <p>This video call is being recorded</p>
        </Modal>
      </div>

      <Modal open={endModal} title={<><span>End Meeting</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeEndModal}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={closeEndModal}
          >
            Cancel
          </Button>,
          <Button type="primary" className="buttonSave deletebtn"
            onClick={endall}
          >
            Yes, End Meeting
          </Button>,
        ]}>
        <p>Are you sure, you want to end this meeting?</p>
      </Modal>



    </>
  );

};
